var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12,
    r: 11.5,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.38628H7.61111M7.61111 8.38628H16.5M7.61111 8.38628V16.1641C7.61111 16.4587 7.72817 16.7414 7.93655 16.9497C8.14492 17.1581 8.42754 17.2752 8.72222 17.2752H14.2778C14.5725 17.2752 14.8551 17.1581 15.0635 16.9497C15.2718 16.7414 15.3889 16.4587 15.3889 16.1641V8.38628H7.61111ZM9.27778 8.38628V7.27517C9.27778 6.98049 9.39484 6.69787 9.60322 6.4895C9.81159 6.28113 10.0942 6.16406 10.3889 6.16406H12.6111C12.9058 6.16406 13.1884 6.28113 13.3968 6.4895C13.6052 6.69787 13.7222 6.98049 13.7222 7.27517V8.38628",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconSmall);
export default __webpack_public_path__ + "static/media/Delete-icon-small.322c42196d132de152a39d17fff59792.svg";
export { ForwardRef as ReactComponent };